module.exports = __webpack_public_path__ + "img/connect-1.dd401fd3.svg";